module.exports = __webpack_public_path__ + "img/restaurant-square-red.09e73955.svg";